export const removePortNumberFromURL = (url) => {
  if (url.includes("localhost:8008")) {
    return url;
  }

  return url.replace(":8008/", "/");
};